import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelSection = ({
  children,
  showBorders = true,
  title
}) => /*#__PURE__*/_jsxs(View, {
  borderBlockStartColor: "border-core-subtle",
  borderBlockStartStyle: "solid",
  borderBlockStartWidth: "100",
  marginBlockStart: "-25",
  children: [/*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    borderColor: "border-core-subtle",
    borderStyle: showBorders ? 'solid' : 'none',
    borderWidth: showBorders ? '100' : '0',
    paddingBlock: "300",
    paddingInline: "500",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h7",
      children: title
    })
  }), children]
});
export default PanelSection;